import type { SchedulePage, ScheduleRow } from '@rtkwlf/rendall';

import {
  getDateTimeByTz,
  type TimeZone,
} from '../../../../../../../../../../utils/get-date-time-by-tz';
import { PriorityOptions } from '../../../../../../../../../scan-schedules/components/new-scan-schedules/form-types';

interface ScanningScheduleRow extends ScheduleRow {
  scanPriority: string;
  targetsStr: string;
  targetScanningStatus: string;
  tzNextScan: string;
}

enum ScanPriority {
  High = 'high',
  Medium = 'medium',
  Low = 'low',
}

enum TargetScanning {
  Enabled = 'enabled',
  Disabled = 'disabled',
}

const getPriority = (priority: number) => {
  switch (priority.toString()) {
    case PriorityOptions.High:
      return ScanPriority.High;
    case PriorityOptions.Medium:
      return ScanPriority.Medium;
    case PriorityOptions.Low:
      return ScanPriority.Low;
    default:
      return '';
  }
};

export const prepareScanningScheduleData = (
  data: SchedulePage,
  timezone: TimeZone,
): ScanningScheduleRow[] => {
  const scanningSchedule = data.items.map((row) => {
    const scanPriority = getPriority(row.priority);
    const targetsStr = row.targets.map((target) => target.ipAddress).join();
    const tzNextScan = getDateTimeByTz(row.nextScan, timezone);

    return {
      ...row,
      scanPriority,
      targetScanningStatus: row.scanningEnabled
        ? TargetScanning.Enabled
        : TargetScanning.Disabled,
      targetsStr,
      tzNextScan,
    };
  });

  return scanningSchedule;
};
